// import React from "react";
// import { motion } from "framer-motion";
// import { useNavigate } from "react-router-dom";
// import {
//   ShieldCheck,
//   Server,
//   LayoutDashboard,
//   Cpu,
//   Database,
//   Layers,
//   Cloud,
//   FileText,
//   ArrowRight,
//   Monitor,
//   Settings2,
//   Bell,
//   TriangleAlert,
//   Globe,
//   HardDrive,
//   Activity,
//   Smartphone,
//   Grid3X3,
// } from "lucide-react";

// export function renderapps() {
//   return <AppsLanding />;
// }

// // ─── gradient configs per card ───────────────────────────────────────────────
// const CARD_GRADIENTS = [
//   "from-sky-400 to-indigo-500",
//   "from-emerald-400 to-cyan-500",
//   "from-orange-400 to-red-500",
//   "from-yellow-400 to-green-500",
//   "from-indigo-400 to-purple-500",
//   "from-cyan-400 to-indigo-500",
//   "from-emerald-400 to-teal-500",
//   "from-amber-400 to-red-500",
//   "from-sky-400 to-purple-500",
//   "from-rose-400 to-orange-500",
//   "from-purple-400 to-pink-500",
//   "from-blue-700 to-sky-400",
// ];

// function pickGradient(index) {
//   return CARD_GRADIENTS[index % CARD_GRADIENTS.length];
// }

// // ─── Tile card ────────────────────────────────────────────────────────────────
// function Tile({ title, route, subtitle, gradientIndex = 0 }) {
//   const navigate = useNavigate();
//   const gradient = pickGradient(gradientIndex);

//   return (
//     <motion.button
//       onClick={() => navigate(route)}
//       whileHover={{ y: -4 }}
//       whileTap={{ scale: 0.97 }}
//       className="group w-full text-left bg-white dark:bg-[#0e141b] border border-slate-200/70 dark:border-white/10 rounded-[14px] overflow-visible relative cursor-pointer flex flex-col justify-between"
//       style={{ isolation: "isolate" }}
//     >
//       <div>
//         <div className="relative pb-5">
//           <div className={`h-[52px] rounded-t-[14px] overflow-hidden relative bg-gradient-to-r ${gradient}`}>
//             <svg className="absolute bottom-0 left-0 w-full h-6" viewBox="0 0 200 24" preserveAspectRatio="none">
//               <path d="M0 12 Q50 0 100 12 Q150 24 200 12 L200 24 L0 24Z" fill="white" fillOpacity="0.13" />
//             </svg>
//           </div>

//           <div
//             className={`absolute bottom-0 left-1/2 -translate-x-1/2 w-[38px] h-[38px] rounded-[11px] flex items-center justify-center text-xs font-bold text-white border-3 border-white dark:border-[#0e141b] shadow-[0_2px_10px_rgba(0,0,0,0.2)] z-10 bg-gradient-to-br ${gradient}`}
//           >
//             {title.slice(0, 2).toUpperCase()}
//           </div>
//         </div>

//         <div className="pt-2 pb-2.5 px-3 text-center">
//           <div className="text-[12px] font-medium text-slate-900 dark:text-white">
//             {title}
//           </div>
//           <div className="text-[10px] text-slate-400 dark:text-slate-500 mt-px">
//             {subtitle}
//           </div>
//         </div>
//       </div>

//       <div className="flex items-center gap-1.5 px-3 py-1.5 border-t border-slate-200/70 dark:border-white/10 text-[10px] text-slate-400 dark:text-slate-500">
//         <FileText className="w-3 h-3" />
//         <span>Open</span>
//         <div className="ml-auto flex items-center bg-slate-100 dark:bg-white/5 border border-slate-200/70 dark:border-white/10 rounded-full px-2 py-0.5 font-medium group-hover:bg-slate-200 dark:group-hover:bg-white/10 transition-colors">
//           <ArrowRight className="w-2.5 h-2.5" />
//         </div>
//       </div>
//     </motion.button>
//   );
// }

// // ─── SectionCard ─────────────────────────────────────────────────────────────
// function SectionCard({
//   title,
//   description,
//   icon: Icon,
//   headerBg,
//   meta,
//   children,
// }) {
//   return (
//     <div className="mb-5 rounded-[20px] bg-white dark:bg-[#0e141b] border border-slate-200/70 dark:border-white/10 overflow-hidden">
//       <div className="flex items-center gap-3 px-[1.1rem] py-[0.85rem] bg-slate-50 dark:bg-white/[0.02] border-b border-slate-200/70 dark:border-white/10">
//         <div
//           className="w-9 h-9 rounded-[10px] flex items-center justify-center text-lg flex-shrink-0 text-white"
//           style={{ background: headerBg }}
//         >
//           <Icon className="w-[18px] h-[18px]" />
//         </div>
//         <div>
//           <div className="text-[14px] font-medium text-slate-900 dark:text-white">
//             {title}
//           </div>
//           <div className="text-[12px] text-slate-400 dark:text-slate-500 mt-px">
//             {description}
//           </div>
//         </div>
//         <span className="ml-auto text-[11px] px-2.5 py-0.5 rounded-full bg-white dark:bg-[#0e141b] border border-slate-200/70 dark:border-white/10 text-slate-400 dark:text-slate-500 whitespace-nowrap flex-shrink-0">
//           {meta}
//         </span>
//       </div>

//       <div className="p-[0.85rem] grid grid-cols-[repeat(auto-fill,minmax(140px,1fr))] gap-2.5">
//         {children}
//       </div>
//     </div>
//   );
// }

// // ─── Main page ────────────────────────────────────────────────────────────────
// export default function AppsLanding() {
//   return (
//     <div className="w-full max-w-[1100px] mx-auto py-6 px-4" id="overview">
//       <h2 className="sr-only">Apps documentation navigation.</h2>

//       <div className="inline-flex items-center gap-1.5 bg-orange-500/10 dark:bg-orange-500/15 border border-orange-500/25 dark:border-orange-500/30 text-[11px] font-medium tracking-widest uppercase px-3 py-1 rounded-full mb-4">
//   <ShieldCheck className="w-3.5 h-3.5 text-orange-500" />
//   <span className="bg-gradient-to-r from-orange-500 to-red-500 bg-clip-text text-transparent">
//     Documentation
//   </span>
// </div>

//       <h1 className="text-5xl font-bold tracking-tight mb-2 bg-gradient-to-r from-orange-600 to-red-600 bg-clip-text text-transparent leading-[1.15]">
//         Apps
//       </h1>

//       <p className="text-[15px] text-slate-500 dark:text-slate-400 leading-[1.6] mb-8 max-w-[760px]">
//         Discover a wide range of applications and subcomponents designed to give you complete visibility and control. Each module is crafted to provide clear insights, seamless navigation, and actionable information — making it easy to explore, monitor, and optimize your environment with confidence.
//       </p>

//       <SectionCard
//         title="Home"
//         description="Central entry point for service visibility and quick health checks."
//         icon={Monitor}
//         headerBg="linear-gradient(135deg,#38bdf8,#6366f1)"
//         meta="2 sub apps"
//       >
//         <Tile
//           title="Services"
//           route="/homeservices"
//           subtitle="Complete service list"
//           gradientIndex={0}
//         />
//         <Tile
//           title="Overview"
//           route="/apps/home/overview"
//           subtitle="Overall service health"
//           gradientIndex={1}
//         />
//       </SectionCard>

//       <SectionCard
//         title="Dashboard"
//         description="Build and view customized monitoring dashboards."
//         icon={LayoutDashboard}
//         headerBg="linear-gradient(135deg,#8b5cf6,#ec4899)"
//         meta="1 sub app"
//       >
//         <Tile
//           title="Custom Dashboard"
//           route="/apps/dashboard/custom-dashboard"
//           subtitle="Configurable widgets"
//           gradientIndex={4}
//         />
//       </SectionCard>

//       <SectionCard
//         title="Infrastructure"
//         description="Infrastructure monitoring across hosts and core services."
//         icon={Server}
//         headerBg="linear-gradient(135deg,#f97316,#ef4444)"
//         meta="4 sub apps"
//       >
//         <Tile title="Host" route="/apps/infrastructure/host" subtitle="Hosts and metrics" gradientIndex={2} />
//         <Tile title="Redis" route="/apps/infrastructure/redis" subtitle="Memory and latency" gradientIndex={3} />
//         <Tile title="NGNIX" route="/apps/infrastructure/ngnix" subtitle="Server uptime" gradientIndex={5} />
//         <Tile title="IIS" route="/apps/infrastructure/iis" subtitle="Web server health" gradientIndex={6} />
//       </SectionCard>

//       <SectionCard
//         title="Database"
//         description="Database visibility for relational and non-relational systems."
//         icon={Database}
//         headerBg="linear-gradient(135deg,#f59e0b,#ef4444)"
//         meta="2 sub apps"
//       >
//         <Tile title="Relational" route="/apps/database/relational" subtitle="SQL database insights" gradientIndex={7} />
//         <Tile title="Non-relational" route="/apps/database/non-relational" subtitle="NoSQL monitoring" gradientIndex={8} />
//       </SectionCard>

//       <SectionCard
//         title="RUM"
//         description="Real user monitoring for browser and mobile experiences."
//         icon={Activity}
//         headerBg="linear-gradient(135deg,#22c55e,#14b8a6)"
//         meta="2 sub apps"
//       >
//         <Tile title="BRUM" route="/apps/rum/brum" subtitle="Browser user experience" gradientIndex={9} />
//         <Tile title="MRUM" route="/apps/rum/mrum" subtitle="Mobile performance" gradientIndex={10} />
//       </SectionCard>

//       <SectionCard
//         title="Cloud"
//         description="Cloud services and Kubernetes platform monitoring."
//         icon={Cloud}
//         headerBg="linear-gradient(135deg,#818cf8,#38bdf8)"
//         meta="4 sub apps"
//       >
//         <Tile title="API Gateway" route="/apps/cloud/api-gateway" subtitle="Traffic and latency" gradientIndex={11} />
//         <Tile title="EKS" route="/apps/cloud/eks" subtitle="Amazon Kubernetes" gradientIndex={0} />
//         <Tile title="RDS" route="/apps/cloud/rds" subtitle="Amazon databases" gradientIndex={1} />
//         <Tile title="AKS" route="/apps/cloud/aks" subtitle="Azure Kubernetes" gradientIndex={2} />
//       </SectionCard>

//       <SectionCard
//         title="Message Queue"
//         description="Queue and broker monitoring for event-driven systems."
//         icon={Layers}
//         headerBg="linear-gradient(135deg,#c084fc,#f472b6)"
//         meta="3 sub apps"
//       >
//         <Tile title="Active MQ" route="/apps/message-queue/active-mq" subtitle="Broker throughput" gradientIndex={4} />
//         <Tile title="Kafka" route="/apps/message-queue/kafka" subtitle="Partition health" gradientIndex={5} />
//         <Tile title="Rabbit MQ" route="/apps/message-queue/rabbit-mq" subtitle="Queue stability" gradientIndex={6} />
//       </SectionCard>

//       <SectionCard
//         title="Reports"
//         description="Generate reports to review monitoring trends and insights."
//         icon={FileText}
//         headerBg="linear-gradient(135deg,#0ea5e9,#2563eb)"
//         meta="1 sub app"
//       >
//         <Tile title="HTML Report" route="/apps/reports/html-report" subtitle="Detailed summaries" gradientIndex={3} />
//       </SectionCard>

//       <SectionCard
//         title="Configuration"
//         description="Administrative settings for access and system configuration."
//         icon={Settings2}
//         headerBg="linear-gradient(135deg,#14b8a6,#0f766e)"
//         meta="1 sub app"
//       >
//         <Tile title="Admin-Config" route="/apps/configuration/admin-config" subtitle="Admin controls" gradientIndex={8} />
//       </SectionCard>

//       <SectionCard
//         title="Alerts and Problems"
//         description="Review alerts and investigate problems quickly."
//         icon={Bell}
//         headerBg="linear-gradient(135deg,#f43f5e,#fb7185)"
//         meta="2 sub apps"
//       >
//         <Tile title="Alerts" route="/apps/alerts-and-problems/alerts" subtitle="Triggered notifications" gradientIndex={9} />
//         <Tile title="Problems" route="/apps/alerts-and-problems/problems" subtitle="Troubleshooting details" gradientIndex={10} />
//       </SectionCard>
//     </div>
//   );
// }

import React from "react";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import {
  ShieldCheck,
  Server,
  LayoutDashboard,
  Database,
  Layers,
  Cloud,
  FileText,
  ArrowRight,
  Monitor,
  Settings2,
  Bell,
  Activity,
  Lock,
} from "lucide-react";

export function renderapps() {
  return <AppsLanding />;
}

const CARD_GRADIENTS = [
  "from-sky-400 to-indigo-500",
  "from-emerald-400 to-cyan-500",
  "from-orange-400 to-red-500",
  "from-yellow-400 to-green-500",
  "from-indigo-400 to-purple-500",
  "from-cyan-400 to-indigo-500",
  "from-emerald-400 to-teal-500",
  "from-amber-400 to-red-500",
  "from-sky-400 to-purple-500",
  "from-rose-400 to-orange-500",
  "from-purple-400 to-pink-500",
  "from-blue-700 to-sky-400",
];

function pickGradient(index) {
  return CARD_GRADIENTS[index % CARD_GRADIENTS.length];
}

function Tile({ title, route, subtitle, gradientIndex = 0, disabled = false }) {
  const navigate = useNavigate();
  const gradient = pickGradient(gradientIndex);

  if (disabled) {
    return (
      <div
        className="group w-full text-left bg-white dark:bg-[#0e141b] border border-slate-200/70 dark:border-white/10 rounded-[14px] overflow-visible relative flex flex-col justify-between cursor-not-allowed select-none"
        style={{ isolation: "isolate" }}
      >
        {/* Coming Soon ribbon */}
        <div className="absolute top-2 right-2 z-20 flex items-center gap-1 px-2 py-0.5 rounded-full bg-black/40 backdrop-blur-sm border border-white/20 text-[9px] font-semibold text-white tracking-wide">
          <Lock className="w-2.5 h-2.5" />
          Soon
        </div>

        <div>
          <div className="relative pb-5">
            {/* Banner — full color, just slightly dimmed */}
            <div className={`h-[52px] rounded-t-[14px] overflow-hidden relative bg-gradient-to-r ${gradient} opacity-75`}>
              <svg className="absolute bottom-0 left-0 w-full h-6" viewBox="0 0 200 24" preserveAspectRatio="none">
                <path d="M0 12 Q50 0 100 12 Q150 24 200 12 L200 24 L0 24Z" fill="white" fillOpacity="0.13" />
              </svg>
            </div>

            {/* Avatar — full color */}
            <div className={`absolute bottom-0 left-1/2 -translate-x-1/2 w-[38px] h-[38px] rounded-[11px] flex items-center justify-center text-xs font-bold text-white border-3 border-white dark:border-[#0e141b] shadow-[0_2px_10px_rgba(0,0,0,0.2)] z-10 bg-gradient-to-br ${gradient} opacity-75`}>
              {title.slice(0, 2).toUpperCase()}
            </div>
          </div>

          <div className="pt-2 pb-2.5 px-3 text-center">
            <div className="text-[12px] font-medium text-slate-400 dark:text-slate-500">
              {title}
            </div>
            <div className="text-[10px] text-slate-300 dark:text-slate-600 mt-px">
              {subtitle}
            </div>
          </div>
        </div>

        <div className="flex items-center gap-1.5 px-3 py-1.5 border-t border-slate-200/70 dark:border-white/10 text-[10px] text-slate-300 dark:text-slate-600">
          <Lock className="w-3 h-3" />
          <span>Coming Soon</span>
        </div>
      </div>
    );
  }

  return (
    <motion.button
      onClick={() => navigate(route)}
      whileHover={{ y: -4 }}
      whileTap={{ scale: 0.97 }}
      className="group w-full text-left bg-white dark:bg-[#0e141b] border border-slate-200/70 dark:border-white/10 rounded-[14px] overflow-visible relative cursor-pointer flex flex-col justify-between"
      style={{ isolation: "isolate" }}
    >
      <div>
        <div className="relative pb-5">
          <div className={`h-[52px] rounded-t-[14px] overflow-hidden relative bg-gradient-to-r ${gradient}`}>
            <svg className="absolute bottom-0 left-0 w-full h-6" viewBox="0 0 200 24" preserveAspectRatio="none">
              <path d="M0 12 Q50 0 100 12 Q150 24 200 12 L200 24 L0 24Z" fill="white" fillOpacity="0.13" />
            </svg>
          </div>
          <div className={`absolute bottom-0 left-1/2 -translate-x-1/2 w-[38px] h-[38px] rounded-[11px] flex items-center justify-center text-xs font-bold text-white border-3 border-white dark:border-[#0e141b] shadow-[0_2px_10px_rgba(0,0,0,0.2)] z-10 bg-gradient-to-br ${gradient}`}>
            {title.slice(0, 2).toUpperCase()}
          </div>
        </div>

        <div className="pt-2 pb-2.5 px-3 text-center">
          <div className="text-[12px] font-medium text-slate-900 dark:text-white">
            {title}
          </div>
          <div className="text-[10px] text-slate-400 dark:text-slate-500 mt-px">
            {subtitle}
          </div>
        </div>
      </div>

      <div className="flex items-center gap-1.5 px-3 py-1.5 border-t border-slate-200/70 dark:border-white/10 text-[10px] text-slate-400 dark:text-slate-500">
        <FileText className="w-3 h-3" />
        <span>Open</span>
        <div className="ml-auto flex items-center bg-slate-100 dark:bg-white/5 border border-slate-200/70 dark:border-white/10 rounded-full px-2 py-0.5 font-medium group-hover:bg-slate-200 dark:group-hover:bg-white/10 transition-colors">
          <ArrowRight className="w-2.5 h-2.5" />
        </div>
      </div>
    </motion.button>
  );
}

function SectionCard({ title, description, icon: Icon, headerBg, meta, children }) {
  return (
    <div className="mb-5 rounded-[20px] bg-white dark:bg-[#0e141b] border border-slate-200/70 dark:border-white/10 overflow-hidden">
      <div className="flex items-center gap-3 px-[1.1rem] py-[0.85rem] bg-slate-50 dark:bg-white/[0.02] border-b border-slate-200/70 dark:border-white/10">
        <div
          className="w-9 h-9 rounded-[10px] flex items-center justify-center flex-shrink-0 text-white"
          style={{ background: headerBg }}
        >
          <Icon className="w-[18px] h-[18px]" />
        </div>
        <div>
          <div className="text-[14px] font-medium text-slate-900 dark:text-white">{title}</div>
          <div className="text-[12px] text-slate-400 dark:text-slate-500 mt-px">{description}</div>
        </div>
        <span className="ml-auto text-[11px] px-2.5 py-0.5 rounded-full bg-white dark:bg-[#0e141b] border border-slate-200/70 dark:border-white/10 text-slate-400 dark:text-slate-500 whitespace-nowrap flex-shrink-0">
          {meta}
        </span>
      </div>
      <div className="p-[0.85rem] grid grid-cols-[repeat(auto-fill,minmax(140px,1fr))] gap-2.5">
        {children}
      </div>
    </div>
  );
}

export default function AppsLanding() {
  return (
    <div className="w-full max-w-[1100px] mx-auto py-6 px-4" id="overview">
      <h2 className="sr-only">Apps documentation navigation.</h2>

      <div className="inline-flex items-center gap-1.5 bg-orange-500/10 dark:bg-orange-500/15 border border-orange-500/25 dark:border-orange-500/30 text-[11px] font-medium tracking-widest uppercase px-3 py-1 rounded-full mb-4">
        <ShieldCheck className="w-3.5 h-3.5 text-orange-500" />
        <span className="bg-gradient-to-r from-orange-500 to-red-500 bg-clip-text text-transparent">
          Documentation
        </span>
      </div>

      <h1 className="text-5xl font-bold tracking-tight mb-2 bg-gradient-to-r from-orange-600 to-red-600 bg-clip-text text-transparent leading-[1.15]">
        Apps
      </h1>

      <p className="text-[15px] text-slate-500 dark:text-slate-400 leading-[1.6] mb-8 max-w-[760px]">
        Discover a wide range of applications and subcomponents designed to give you complete visibility and control. Each module is crafted to provide clear insights, seamless navigation, and actionable information — making it easy to explore, monitor, and optimize your environment with confidence.
      </p>

      <SectionCard
        title="Home"
        description="Central entry point for service visibility and quick health checks."
        icon={Monitor}
        headerBg="linear-gradient(135deg,#38bdf8,#6366f1)"
        meta="2 sub apps"
      >
        <Tile title="Services" route="/homeservices" subtitle="Complete service list" gradientIndex={0} />
        <Tile title="Overview" route="/apps/home/overview" subtitle="Overall service health" gradientIndex={1} disabled />
      </SectionCard>

      <SectionCard
        title="Dashboard"
        description="Build and view customized monitoring dashboards."
        icon={LayoutDashboard}
        headerBg="linear-gradient(135deg,#8b5cf6,#ec4899)"
        meta="1 sub app"
      >
        <Tile title="Custom Dashboard" route="/apps/dashboard/custom-dashboard" subtitle="Configurable widgets" gradientIndex={4} disabled />
      </SectionCard>

      <SectionCard
        title="Infrastructure"
        description="Infrastructure monitoring across hosts and core services."
        icon={Server}
        headerBg="linear-gradient(135deg,#f97316,#ef4444)"
        meta="4 sub apps"
      >
        <Tile title="Host" route="/infrahost" subtitle="Hosts and metrics" gradientIndex={2} />
        <Tile title="Redis" route="/infraredis" subtitle="Memory and latency" gradientIndex={3} />
        <Tile title="NGNIX" route="/apps/infrastructure/ngnix" subtitle="Server uptime" gradientIndex={5} disabled />
        <Tile title="IIS" route="/apps/infrastructure/iis" subtitle="Web server health" gradientIndex={6} disabled />
      </SectionCard>

      <SectionCard
        title="Database"
        description="Database visibility for relational and non-relational systems."
        icon={Database}
        headerBg="linear-gradient(135deg,#f59e0b,#ef4444)"
        meta="2 sub apps"
      >
        <Tile title="Database" route="/db" subtitle="SQL database insights" gradientIndex={7}  />
        {/* <Tile title="Non-relational" route="/dbnonrelational" subtitle="NoSQL monitoring" gradientIndex={8}  /> */}
      </SectionCard>

      <SectionCard
        title="RUM"
        description="Real user monitoring for browser and mobile experiences."
        icon={Activity}
        headerBg="linear-gradient(135deg,#22c55e,#14b8a6)"
        meta="2 sub apps"
      >
        <Tile title="BRUM" route="/apps/rum/brum" subtitle="Browser user experience" gradientIndex={9} disabled />
        <Tile title="MRUM" route="/apps/rum/mrum" subtitle="Mobile performance" gradientIndex={10} disabled />
      </SectionCard>

      <SectionCard
        title="Cloud"
        description="Cloud services and Kubernetes platform monitoring."
        icon={Cloud}
        headerBg="linear-gradient(135deg,#818cf8,#38bdf8)"
        meta="4 sub apps"
      >
        <Tile title="API Gateway" route="/apps/cloud/api-gateway" subtitle="Traffic and latency" gradientIndex={11} disabled />
        <Tile title="EKS" route="/apps/cloud/eks" subtitle="Amazon Kubernetes" gradientIndex={0} disabled />
        <Tile title="RDS" route="/apps/cloud/rds" subtitle="Amazon databases" gradientIndex={1} disabled />
        <Tile title="AKS" route="/apps/cloud/aks" subtitle="Azure Kubernetes" gradientIndex={2} disabled />
      </SectionCard>

      <SectionCard
        title="Message Queue"
        description="Queue and broker monitoring for event-driven systems."
        icon={Layers}
        headerBg="linear-gradient(135deg,#c084fc,#f472b6)"
        meta="3 sub apps"
      >
        <Tile title="Active MQ" route="/apps/message-queue/active-mq" subtitle="Broker throughput" gradientIndex={4} disabled />
        <Tile title="Kafka" route="/apps/message-queue/kafka" subtitle="Partition health" gradientIndex={5} disabled />
        <Tile title="Rabbit MQ" route="/apps/message-queue/rabbit-mq" subtitle="Queue stability" gradientIndex={6} disabled />
      </SectionCard>

      <SectionCard
        title="Reports"
        description="Generate reports to review monitoring trends and insights."
        icon={FileText}
        headerBg="linear-gradient(135deg,#0ea5e9,#2563eb)"
        meta="1 sub app"
      >
        <Tile title="HTML Report" route="/apps/reports/html-report" subtitle="Detailed summaries" gradientIndex={3} disabled />
      </SectionCard>

      <SectionCard
        title="Configuration"
        description="Administrative settings for access and system configuration."
        icon={Settings2}
        headerBg="linear-gradient(135deg,#14b8a6,#0f766e)"
        meta="1 sub app"
      >
        <Tile title="Admin-Config" route="/configadmin" subtitle="Admin controls" gradientIndex={8} disabled />
      </SectionCard>

      <SectionCard
        title="Alerts and Problems"
        description="Review alerts and investigate problems quickly."
        icon={Bell}
        headerBg="linear-gradient(135deg,#f43f5e,#fb7185)"
        meta="2 sub apps"
      >
        <Tile title="Alerts" route="/apps/alerts-and-problems/alerts" subtitle="Triggered notifications" gradientIndex={9} disabled />
        <Tile title="Problems" route="/apps/alerts-and-problems/problems" subtitle="Troubleshooting details" gradientIndex={10} disabled />
      </SectionCard>
    </div>
  );
}